module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "more-info",
    style: ({
      borderColor: _vm.borderColour
    })
  }, [_c('div', {
    staticClass: "controls",
    style: ({
      backgroundColor: _vm.borderColour
    }),
    on: {
      "click": function($event) {
        _vm.open = !_vm.open
      }
    }
  }, [_c('p', {
    staticClass: "control-text"
  }, [_vm._v("TOGGLE  KEY  ON / OFF")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "css": false
    },
    on: {
      "enter": _vm.show,
      "leave": _vm.hide
    }
  }, [(_vm.open) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header",
    style: ({
      backgroundColor: _vm.borderColour
    })
  }, [_c('span', {
    staticClass: "header-text"
  }, [_vm._v(_vm._s(_vm.keyString) + " Key")])]), _vm._v(" "), (_vm.key == 0) ? _c('div', {
    staticClass: "scrolling"
  }, [_c('map-key')], 1) : (_vm.key === 1) ? _c('div', {
    staticClass: "scrolling"
  }, [_c('bluebell-key')], 1) : (_vm.key === 2) ? _c('div', {
    staticClass: "scrolling"
  }, [_c('wild-flower-key')], 1) : (_vm.key === 3) ? _c('div', {
    staticClass: "scrolling"
  }, [_c('tree-key')], 1) : _vm._e()]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47e1d309"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom/Key.vue
// module id = 97
// module chunks = 1